import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  topSection: {
    display: 'flex',
    flexDirection: 'row',
    padding: '24px',
    width: '100%',
    gap: '16px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
  },
  companyNameSection: {
    gap: '10px',
    width: '100%',
  },
  companyTitleText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    textTransform: 'capitalize',
  },
  companyAddressText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
  },
  editOutlineButton: {
    alignSelf: 'start',
    textAlign: 'center',
    boxSizing: 'border-box',
    width: '48px',
    height: '32px',
    border: `1px solid ${theme.evPalette.ocean[500]}`,
    borderRadius: '4px',
    backgroundColor: theme.evPalette.salt[100],
  },
}));
